/* eslint-disable */
/* eslint-disable-next-line no-unused-vars */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import InstantSearch from 'vue-instantsearch/vue3/es'
import './index.css'

const app = createApp(App)
app.use(router)
app.use(InstantSearch)
app.mount('#app')

const geval = eval
